import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT
/**
 *
 * @param params
 * @returns {AxiosPromise<any>}
 */


//保存
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/pay/payaccount/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/pay/payaccount/save', qs.stringify(params))
  }
}

export const getListData = (params) => {
  return axios.post(root + '/pay/payaccount/list', qs.stringify(params))
}

export const getSelListData = (params) => {
  return axios.post(root + '/pay/payaccount/selListDate', qs.stringify(params))
}

export const getDetail = (params) => {
  return axios.post(root + '/pay/payaccount/detail', qs.stringify(params))
}

export const deleteData = (params) => {
  return axios.post(root + '/pay/payaccount/remove', qs.stringify(params))
}


export const querybyDeptName = (params) => {
  return axios.post(root + '/pay/payaccount/querybyDeptName', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/pay/payaccount.js